<template>
    <layout-authenticated>
        <v-breadcrumbs :items="breadcrumb"></v-breadcrumbs>
        <h1 class="mb-3">{{ $t('approval.approval') }}</h1>
        <!-- all orders -->
        <div class="d-flex justify-space-between">
            <h3 class="mb-3">{{ $t('approval.orders_approval') }}</h3>
            <v-switch
                v-model="form.including_orders_from_bulk_order"
                :label="$t('orders.including_orders_from_bulk_order')"
            />
        </div>
        <orders-table
            url="/api/orders/for-approval"
            :including-orders-from-bulk-order="form.including_orders_from_bulk_order"
        />
        <!-- bulk orders -->
        <h3 class="mb-3">{{ $t('approval.bulk_orders_approval') }}</h3>
        <bulk-orders-table url="/api/bulk-orders/for-approval"/>
    </layout-authenticated>
</template>

<script>
import LayoutAuthenticated from "@/layouts/LayoutAuthenticated";
import BulkOrdersTable from "@/components/user/orders/BulkOrdersTable";
import OrdersTable from "@/components/user/orders/OrdersTable";

export default {
    name: 'Approval',
    components: {OrdersTable, BulkOrdersTable, LayoutAuthenticated},
    data: () => ({
        form: {
            including_orders_from_bulk_order: false
        }
    }),
    computed: {
        breadcrumb() {
            return [
                {
                    text: this.$t('app.name'),
                    href: '/'
                },
                {
                    text: this.$t('approval.approval'),
                    href: '/approver/approval',
                    disabled: true
                }
            ];
        }
    }

}
</script>
